import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { contactsUrl as ContactsQK } from './api';
import { ResponseType } from 'src/constants/data';
import { ContactFilters, ContactTagFilter } from 'src/types';

export const useGetContacts = (params: Partial<ContactFilters>) => {
  return useQuery({
    queryKey: [ContactsQK, ResponseType.List, params],
    queryFn: () => API.getContacts(params),
    placeholderData: keepPreviousData
  });
};

export const useGetTags = (params: Partial<ContactTagFilter>) => {
  return useQuery({
    queryKey: [ContactsQK + '/tags', ResponseType.List, params],
    queryFn: () => API.getTags(params),
    placeholderData: keepPreviousData,
    enabled: !!params.blockId
  });
};

export const useGetBlock = (slug: string | undefined) => {
  return useQuery({
    queryKey: [ContactsQK, ResponseType.List, slug],
    queryFn: () => API.getBlock(slug),
    placeholderData: keepPreviousData,
    enabled: !!slug
  });
};

export const useGetCards = (params: Partial<ContactFilters> & { blockId: string }) => {
  return useQuery({
    queryKey: [ContactsQK, ResponseType.List, params],
    queryFn: () => API.getBlockCards(params),
    placeholderData: keepPreviousData,
    enabled: !!params.blockId
  });
};

export const useGetBlocks = () => {
  return useQuery({
    queryKey: [ContactsQK + '/tags', ResponseType.List],
    queryFn: () => API.getBlocks(),
    placeholderData: keepPreviousData
  });
};
